import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService } from '../../shared';
import { Core2Config } from '../../shared';
import { ClaimAccountEntitlementEmployeeFileContainerModel } from '../../../../../../models/aggregates/erp/claim-account-file-import/index';

@Injectable({
  providedIn: 'root'
})
export class ClaimAccountEntitlementEmployeeFileService extends BaseApiTemplateService<ClaimAccountEntitlementEmployeeFileContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX  + Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'account-entitlement-employee/import-file-hdrs/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'account-entitlement-employee/import-file-hdrs/backoffice-ep';
    this.httpClient = http;
  }

  async sampleTemplateCSV(authorization: string, apiVisa: ApiVisa) {
    const CSV_URL = apiVisa.api_domain_url + this.endpoint_path + '/download-master-data-template';
    const headers = new HttpHeaders({ "authorization": authorization, "tenantCode": apiVisa.tenantCode });
    const fileBlob = await this.httpClient
      .get(CSV_URL, { headers, responseType: 'blob' })
      .toPromise();
    return fileBlob;
  }

}